var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-width-height"},[(_vm.showElopementAlerts)?_c('elopement-alerts',{staticClass:"westchester"}):_c('object-alerts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }